import { routingConfig, TAKEOVER_ROUTES } from '@makemydeal/dr-sales-checkin-types';
import type { ShowrooomLayoutVariant } from '@makemydeal/dr-sales-checkin-components';
import { ShowroomLayout } from '@makemydeal/dr-sales-checkin-components';

export const CREATE_DEAL_LABEL = 'Create Deal';

/**
 * routeLayoutConfig
 *
 * Declarative mapping of route -> layout variant. The layout chrome is a pure
 * function of the current route, so it is derived from this config rather than
 * stored in redux. Order matters: the first matching entry wins.
 */
export const routeLayoutConfig: Array<{ path: string; layout: ShowrooomLayoutVariant }> = [
    { path: routingConfig.MANAGE_DOCUMENTS, layout: ShowroomLayout.BACK },
    ...Object.values(TAKEOVER_ROUTES).map((path) => ({ path, layout: ShowroomLayout.BACK })),
    { path: routingConfig.BASE_ROUTE, layout: ShowroomLayout.SIDEBAR }
];
